export function getEntitiesByIds<T>(entityIds: string[] = [], entities?: CocoApi.Entity[]): T[] {
  const collectedEntities = entityIds
    .map((entityId) => entities?.find((entity) => entity._id === entityId))
    .filter((entity) => !!entity)

  return collectedEntities as unknown as T[]
}
